import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["disabled"]

import BaseIcon from '@/shared/legacy/ui/base-icon/icon.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'remove-button',
  props: {
    disabled: { type: Boolean, default: false }
  },
  emits: ["click"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    type: "button",
    "data-qa": "remove",
    disabled: __props.disabled,
    class: _normalizeClass(_ctx.$style.removeButton),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('click')))
  }, [
    _createVNode(BaseIcon, {
      type: "remove",
      width: 14,
      height: 14
    })
  ], 10, _hoisted_1))
}
}

})